// import { Helmet } from 'react-helmet-async'
import { BoxPage } from '@/components/common'
import { Card } from '@/@core/components/mui/Card'
import { CardContent } from '@mui/material'
import { useRouteQuery } from '@hooks/useRouteQuery'
import { TransactionTableFilter, TransactionTableList } from '@components/transaction'
import { useQuery } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { Transaction } from '@/@data/transactions'

const TransactionPage = () => {
  const { searchQuery, serializeQuery } = useRouteQuery()
  const { __ } = useTranslator()

  const [columnVisibility, setColumnVisibility] = useState<Record<string, boolean>>({
    employer: true, // First column - always true
    employee: true,
    eligibility_rate: true,
    requested_transaction: true,
    total_ewa_disbursement: true,
    expired_contract: true,
    total_transaction_fee: true,
    voucher: true,
    status: true // Last column - always true
  })

  const params = useMemo(
    () =>
      serializeQuery({
        page: searchQuery.get('page'),
        perPage: searchQuery.get('perPage'),
        month: searchQuery.get('month'),
        company_id: searchQuery.get('company_id'),
        status: searchQuery.get('status')
      }),
    [searchQuery]
  )

  const { data: transactionData, refetch } = useQuery({
    ...Transaction.getCompanyTransactions(params),
    enabled: !!params.month
  })

  const handleColumnVisibilityChange = (newVisibility: Record<string, boolean>) => {
    setColumnVisibility(newVisibility)
  }

  return (
    <>
      <BoxPage
        title={__('Transaction Management')}
        breadcrumbs={[
          { label: __('Finance Management') },
          { label: __('Transaction Management'), href: '/cms/finance/transaction' }
        ]}
      >
        <Card
          sx={{
            borderRadius: 3
          }}
        >
          <CardContent sx={{ padding: 0 }}>
            <TransactionTableFilter
              columnVisibility={columnVisibility}
              onColumnVisibilityChange={handleColumnVisibilityChange}
              isTransaction={true}
            />
            <TransactionTableList
              data={transactionData?.data || []}
              meta={(transactionData as any)?.meta}
              refetch={refetch}
              columnVisibility={columnVisibility}
            />
          </CardContent>
        </Card>
      </BoxPage>
    </>
  )
}

export default TransactionPage
